export default function getUserId(userId) {
  const USER_ID_PLACEHOLDER = '__USER_ID__';
  return userId && userId !== USER_ID_PLACEHOLDER ? userId : null;
}
